import { ActionTypes } from '../actions/DisclosureStatementActions';
// import Helpers         from 'app/utils/helpers/Helpers';

var initial_state = {};

var callables = {

	[ActionTypes.update_disclosure_statement](state, action) {
		return Object.assign({}, state, action.disclosure_statement);
	}
};

export default function(state = initial_state, action) {

	if (callables.hasOwnProperty(action.type)) {
		return callables[action.type](state, action);
	}

	return state;
};